import { CustomError, InfoPros, InfoType } from 'interface';
import { create } from 'zustand';


interface InfoStore  {
    info: InfoPros |  null,
    // infoType: InfoType 
    showCustomError: boolean,
    setError: (error: CustomError, showError?: boolean) => void;
    setInfo: (info: InfoPros ) => void;
    resetStore: () => void
}

//Todo: add actual field
export const useInfoStore = create<InfoStore >()((set) => ({
    info:  null,
    showCustomError: false,

    /**
        * Set error information in the store.
        * 
        * @param error The CustomError object containing error details.
        * @param showCustomError Optional boolean to indicate whether to show the custom error. Defaults to false.
        * 
        * @returns void
    */
    setError: (error: CustomError, showCustomError: boolean = false) => set(() => ({ 
        // infoType: "Error", 
        showCustomError: showCustomError,
        info: {
            infoType: "Error", 
            close: () => set(() => ({ info: null, showCustomError: false })),
            show: true,
            title: error?.title || "Failed",
            description: error?.message || "",
            actions: []
         } })),
    setInfo: (info: InfoPros) => set(() => ({ 
        // This only affect when infoType is Error, for other infoType, showCustomError will be false
        showCustomError: info?.infoType === "Error" ? true : false,  
        info:{
            ...info,
            actions: info?.actions || [],
            close: () => set(() => ({ info: null, infoType: null })),
        },  })),
    resetStore: () => set(() => ({ info : null, infoType: null })),

}));


export const setError = (error: CustomError) => useInfoStore.getState().setError(error);
export const setInfo = (info: InfoPros) => useInfoStore.getState().setInfo(info);
export const resetStore = () => useInfoStore.getState().resetStore();